import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { CREATE_WAVE_INLINE_GROUP_MORE_RULES, CREATE_WAVE_INLINE_GROUP_QUICK_RULES, CREATE_WAVE_INLINE_GROUP_RULE_LABELS, type CreateWaveInlineGroupRuleType } from "./createWaveInlineGroupBuilder";
import { DraftChipButton } from "./CreateWaveInlineGroupButtons";
const CREATE_WAVE_INLINE_GROUP_RULE_OPTIONS = [...CREATE_WAVE_INLINE_GROUP_QUICK_RULES, ...CREATE_WAVE_INLINE_GROUP_MORE_RULES] as const;
export function CreateWaveInlineGroupRuleList(t0) {
  const $ = _c(5);
  const {
    disabled,
    onRuleOpen
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== onRuleOpen) {
    t1 = CREATE_WAVE_INLINE_GROUP_RULE_OPTIONS.map(rule => <DraftChipButton key={rule} label={CREATE_WAVE_INLINE_GROUP_RULE_LABELS[rule]} disabled={disabled} compact={true} onClick={() => onRuleOpen(rule)} />);
    $[0] = disabled;
    $[1] = onRuleOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="tw-space-y-3"><div className="tw-flex tw-flex-wrap tw-gap-1.5">{t1}</div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function CreateWaveInlineGroupRuleEditorPanel(t0) {
  const $ = _c(9);
  const {
    activeRule,
    disabled,
    onRuleToggle,
    children
  } = t0;
  let t1;
  if ($[0] !== activeRule || $[1] !== disabled || $[2] !== onRuleToggle) {
    t1 = CREATE_WAVE_INLINE_GROUP_RULE_OPTIONS.map(rule => <DraftChipButton key={rule} label={CREATE_WAVE_INLINE_GROUP_RULE_LABELS[rule]} disabled={disabled} active={activeRule === rule} compact={true} isToggle={true} onClick={() => onRuleToggle(rule)} />);
    $[0] = activeRule;
    $[1] = disabled;
    $[2] = onRuleToggle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="tw-flex tw-flex-wrap tw-gap-1.5">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== t2) {
    t3 = <div className="tw-space-y-3">{t2}{children}</div>;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}